import { Alert, Center } from '@chakra-ui/react';
import { sentryReact } from '@duke-hq/app-provider-web/lib/sentryReact';
import { Component } from 'react';
import { NotFound } from '@duke-hq/ui/components/NotFound/NotFound';

export class ErrorBoundary extends Component<
  {
    children: React.ReactNode;
  },
  {
    error: Error | null;
  }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  // @ts-expect-error -- fix this
  componentDidCatch() {
    // TODO log in sentry
    sentryReact.captureException(this.state.error);
  }

  // @ts-expect-error -- fix this
  render() {
    if (this.state.error?.message === 'No UnitAssessment found') {
      return <NotFound />;
    }
    if (this.state.error) {
      // You can render any custom fallback UI
      return (
        <Center h="100vh">
          <Alert status="error">{this.state.error.stack ?? 'Something went wrong.'}</Alert>
        </Center>
      );
    }

    return this.props.children;
  }
}
